/*global define*/

define([
    'jquery',
    'underscore',
    'backbone',
    '../resources/lang'
], function ($, _, Backbone, lang) {
    'use strict';

    var AssignmentView = Backbone.View.extend({
        template: require('ejs-loader!../templates/Assignment.ejs'),
        events: {
            'click .branch': 'branchHandler',
        },
        render: function(){
            this.$el.html(this.template({
                drawer: this.drawer,
                assignments: this.assignments,
                assignmentName: this.assignmentName,
                assignmentDescription: this.assignmentName,
                assignmentAuthor: this.assignmentAuthor,
                assignment: this.assignment,
                terms: lang.assignment,
                language: language
            }));
        },
        initialize: function(path){
            this.path = path || '';
            this.drawer = "solutions";
            this.assignment = undefined;
            this.assignments = [];
            $.getJSON(this.path+"scripts/resources/assignments_"+language+".json").done(function(data) {
                this.assignments = data;
                this.render();
            }.bind(this));
        },
        open: function(){
            var self = this;
            $("#assignmentDrawer").removeClass("assignmentClosed");
            $("#assignmentPanelHeader").removeClass("assignmentClosed");
            $("#assignmentVisibility").toggleClass("glyphicon glyphicon-minus", true);
            $("#assignmentVisibility").toggleClass("glyphicon glyphicon-plus", false);
            $("#assignmentVisibility").unbind();
            $("#assignmentVisibility").click(function(){
                self.close();
            });
        },
        close: function(){
            var self = this;
            $("#assignmentDrawer").addClass("assignmentClosed");
            $("#assignmentPanelHeader").addClass("assignmentClosed");
            $("#assignmentVisibility").toggleClass("glyphicon glyphicon-plus", true);
            $("#assignmentVisibility").toggleClass("glyphicon glyphicon-minus", false);
            $("#assignmentVisibility").unbind();
            $("#assignmentVisibility").click(function(){
                console.log("click")
                self.open();
            });
        },
        loadAssignment: function(assignment){
            $("#assignmentPanelTitle").html(assignment.name);

            var self = this;
            var path = "http://localhost:9000/scripts/resources/assignments/"+assignment.path+"/assignment.json"
            $.ajax({
                url: path,
                success: function(data){
                    var assignment = JSON.parse(data);
                    self.assignment = assignment.assignmentText;
                    self.render();
                    self.open();
                },
                error: function(err){
                    console.log(err);
                }
            });
        },
        branchHandler: function(event){
            event.stopPropagation()
            var node = $(event.currentTarget);
            var content = $("#assignmentGroup"+node.attr("id"));
            if (node.hasClass("collapsed")){
                node.removeClass("collapsed");
                node.addClass("expanded");
                node.children().each(function(){
                    if ($(this).hasClass("glyphicon")){
                        $(this).addClass("glyphicon-chevron-down");
                        $(this).removeClass("glyphicon-chevron-right")
                    }
                });
                content.css("display", "block");
            }
            else if (node.hasClass("expanded")){
                node.removeClass("expanded");
                node.addClass("collapsed");
                node.children().each(function(){
                    if ($(this).hasClass("glyphicon")){
                        $(this).addClass("glyphicon-chevron-right");
                        $(this).removeClass("glyphicon-chevron-down")
                    }
                });
                content.css("display", "none");
            }
        }

    });
    return AssignmentView;
});
